import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PHONE = '+19862173604';

export default function QuickActions() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const waLink = i18n.language === 'es'
    ? 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.'
    : 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.';

  const actions = [
    {
      icon: 'ri-phone-fill',
      labelKey: 'btn_call_now',
      sublabelKey: 'location_call_sub',
      href: `tel:${PHONE}`,
      bg: 'bg-[#F57F25] hover:bg-[#e06d15]',
      text: 'text-black',
      external: false,
      isButton: false,
    },
    {
      icon: 'ri-whatsapp-line',
      labelKey: 'btn_message_whatsapp',
      sublabelKey: 'location_wa_action_sub',
      href: waLink,
      bg: 'bg-[#25D366] hover:bg-[#1ebe5d]',
      text: 'text-white',
      external: true,
      isButton: false,
    },
    {
      icon: 'ri-restaurant-line',
      labelKey: 'btn_view_menu',
      sublabelKey: 'location_menu_sub',
      href: '/menu',
      bg: 'bg-white/8 hover:bg-white/15 border border-white/10',
      text: 'text-white',
      external: false,
      isButton: true,
    },
  ];

  return (
    <section className="py-14 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-[#F57F25] text-xs font-bold uppercase tracking-widest mb-2">{t('location_quick_eyebrow')}</p>
          <h2 className="text-white font-black text-2xl md:text-3xl uppercase">
            {t('location_quick_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {actions.map((action) => {
            const inner = (
              <>
                <div className="w-12 h-12 flex items-center justify-center bg-black/20 rounded-xl mb-4 mx-auto">
                  <i className={`${action.icon} text-2xl`}></i>
                </div>
                <p className="font-black text-base uppercase tracking-wide">{t(action.labelKey)}</p>
                <p className="text-xs opacity-60 mt-1">{t(action.sublabelKey)}</p>
              </>
            );

            if (action.isButton) {
              return (
                <button
                  key={action.labelKey}
                  onClick={() => navigate('/menu')}
                  className={`flex flex-col items-center text-center py-8 px-6 rounded-2xl transition-all duration-200 cursor-pointer ${action.bg} ${action.text}`}
                >
                  {inner}
                </button>
              );
            }

            return (
              <a
                key={action.labelKey}
                href={action.href}
                target={action.external ? '_blank' : undefined}
                rel={action.external ? 'noopener noreferrer' : undefined}
                className={`flex flex-col items-center text-center py-8 px-6 rounded-2xl transition-all duration-200 cursor-pointer ${action.bg} ${action.text}`}
              >
                {inner}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
